<template>
  <div :class="{ 'data-loading': !catalogData }">
    <WCampaign :campaign="campaignData" />
    <WHomeCategory v-if="categoryData" :category="categoryData" />
    <WCatalog
      v-if="catalogData"
      :id="id"
      :catalog="catalogData"
      class="home-catalog"
    />
    <Footer v-if="!isBandLoading" />
  </div>
</template>
<script>
  import { ref } from 'vue'
  import { getHomeData } from '@/common/requests/data-fetch/get-home-data'
  import { onDisplay } from '@/common/directives'
  import { mapGetters } from 'vuex'
  import WCampaign from '@/views/home/WCampaign.vue'
  import WCatalog from '@/views/home/WCatalog.vue'
  import Footer from '@/components/Footer'
  import WHomeCategory from '@/components/category/Home/WHomeCategory'
  import { useConsentRenew } from '@/common/use/useConsentRenew'

  export default {
    // directive 때문에 vue2, vue3 문법 혼재 -> vue3 standard 문법으로 변경 (setup x)
    components: {
      WCatalog,
      WCampaign,
      Footer,
      WHomeCategory,
    },
    directives: {
      onDisplay,
    },
    computed: {
      ...mapGetters(['isBandLoading']),
    },
    setup() {
      const categoryData = ref(null)
      const campaignData = ref(null)
      const catalogData = ref(null)
      const id = ref('')

      const { checkConsentPromotion } = useConsentRenew()

      const setHome = async () => {
        const { data: homeData } = await getHomeData()

        if (homeData) {
          const { category, catalog, campaign } = homeData?.layout
          categoryData.value = category ?? {}
          catalogData.value = catalog ?? {}
          campaignData.value = campaign ?? {}

          id.value = homeData?.id ?? ''
        }
      }

      const init = () => {
        checkConsentPromotion()
        setHome()
      }

      init()

      return {
        WCampaign,
        WCatalog,
        Footer,
        categoryData,
        campaignData,
        catalogData,
        id,
      }
    },
  }
</script>
<style lang="scss" scoped>
  .home-catalog {
    padding-top: 104px;
  }
  .data-loading {
    .footer {
      display: none;
    }
  }
</style>
